<template>
  <div>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>
        Comments
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row v-if="showSearch" align="center" style="max-width: 300px;">
        <v-text-field flat hide-details single-line
          label="Search comment" class="hidden-sm-and-down"
          v-model="filter.search" @input="search"
        ></v-text-field>
      </v-row>
      <v-btn class="ml-5" icon @click="showSearch = !showSearch">
        <img src="@/assets/icons/search.svg" alt="">
      </v-btn>
    </v-app-bar>
    <div class="ma-4" id="comment-list">
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Author</th>
            <th class="text-left" width="50%">Content</th>
            <th class="text-left">Date</th>
            <th class="text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="comments.data.length">
            <tr v-for="comment in comments.data" :key="comment.id">
              <td class="py-4">
                {{ comment.author.full_name }}
              </td>
              <td class="py-4">
                {{ comment.body }}
              </td>
              <td class="py-4">
                {{ comment.postedDate }}
              </td>
              <td class="py-4">
                <!-- <v-btn class="mx-1" @click="$router.push({name: 'audios.edit', params: {id: audio.id}})" elevation="2" icon>
                  <v-icon>{{ icons.edit }}</v-icon>
                </v-btn> -->
                <v-btn class="mx-1" @click="deleteComment(comment)" elevation="2" icon>
                  <v-icon>{{ icons.delete }}</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center headline grey--text py-10" colspan="7">
              No comments available.
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
    <div class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="comments.meta.current_page"
        :length="paginationLength"
        :total-visible="comments.meta.per_page"
        circle
      >
      </v-pagination>
    </div>
  </div>
</template>

<script>
import Comment from '@/models/Comment'
import debounce from 'lodash/debounce'
import { mdiMagnify, mdiTrashCan } from '@mdi/js'

export default {
  data () {
    return {
      loading: false,
      showSearch: false,
      filter: {
        search: ''
      },
      icons: {
        search: mdiMagnify,
        delete: mdiTrashCan
      },
      comments: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  computed: {
    paginationLength () {
      return this.comments.meta.last_page
    }
  },

  methods: {
    pageChanged (page) {
      this.getComments(page)
    },

    search: debounce(function () {
      this.getComments()
    }, 600),

    getComments () {
      this.loading = true
      return (
        Comment.include(['author'])
          .where('search', this.filter.search)
          .page(parseInt(this.comments.meta.current_page))
          .limit(10)
          .get()
          .then(response => {
            this.comments = response
          })
          .catch(() => {})
          .finally(() => (this.loading = false))
      )
    },

    deleteComment (comment) {
      this.$confirm(
        `Are you sure you want to remove <strong>${
          comment.author.full_name
        }</strong> comment?`
      ).then(res => {
        if (res) {
          this.loading = true
          this.$api.delete(`/comments/${comment.id}`)
            .then(() => (this.getComments()))
            .finally(() => (this.loading = false))
        }
      })
    }
  },

  created () {
    this.getComments()
  }
}
</script>
